import fetch from '@/plugin/axios'

// 新增关键字
export function addKeyword (data) {
  return fetch({
    url: '/api/common/im-keyword/add',
    method: 'Post',
    data: data
  })
}

// 关键字列表
export function getKeywordList (data) {
  return fetch({
    url: '/api/common/im-keyword/list',
    method: 'Post',
    data: data
  })
}

// 删除关键字
export function removeKeyword (id) {
  return fetch({
    url: `/api/common/im-keyword/${id}`,
    method: 'Delete'
  })
}

// 关键字信息
export function getKeywordInfo (id) {
  return fetch({
    url: `/api/common/im-keyword/info/${id}`,
    method: 'Get'
  })
}

// 修改关键字
export function updateKeyword (id, data) {
  return fetch({
    url: `/api/common/im-keyword/${id}`,
    method: 'Put',
    data: data
  })
}

// 回复内容选项
export function replyKeywordOption (data) {
  return fetch({
    url: '/api/common/im-keyword/base/options',
    method: 'Post',
    data: data
  })
}

/**
 * 回复内容
 * @param data
 * @returns {*}
 */

// 回复内容选项
export function replyContentOption (data) {
  return fetch({
    url: '/api/common/im-reply-content/base/options',
    method: 'Post',
    data: data
  })
}

// 新增回复内容
export function addContent (data) {
  return fetch({
    url: '/api/common/im-reply-content/add',
    method: 'Post',
    data: data
  })
}

// 回复内容列表
export function getContentList (data) {
  return fetch({
    url: '/api/common/im-reply-content/list',
    method: 'Post',
    data: data
  })
}

// 删除回复内容
export function removeContent (id) {
  return fetch({
    url: `/api/common/im-reply-content/${id}`,
    method: 'Delete'
  })
}

// 回复内容信息
export function getContentInfo (id) {
  return fetch({
    url: `/api/common/im-reply-content/info/${id}`,
    method: 'Get'
  })
}

// 修改回复内容
export function updateContent (id, data) {
  return fetch({
    url: `/api/common/im-reply-content/${id}`,
    method: 'Put',
    data: data
  })
}

// 问卷选项
export function questionnaireOption (data) {
  return fetch({
    url: '/api/order/questionnaire/base/options',
    method: 'Post',
    data: data
  })
}

// 新增问卷内容
export function addQuestionnaire (data) {
  return fetch({
    url: '/api/order/questionnaire/add',
    method: 'Post',
    data: data
  })
}

// 回复问卷列表
export function getQuestionnaireList (data) {
  return fetch({
    url: '/api/order/questionnaire/list',
    method: 'Post',
    data: data
  })
}

// 删除问卷内容
export function removeQuestionnaire (id) {
  return fetch({
    url: `/api/order/questionnaire/${id}`,
    method: 'Delete'
  })
}

// 回复问卷信息
export function getQuestionnaireInfo (id) {
  return fetch({
    url: `/api/order/questionnaire/info/${id}`,
    method: 'Get'
  })
}

// 修改问卷内容
export function updateQuestionnaire (id, data) {
  return fetch({
    url: `/api/order/questionnaire/${id}`,
    method: 'Put',
    data: data
  })
}

export function humanChatList () {
  return fetch({
    url: `/api/member/account/chat/list`,
    method: 'Get'
  })
}

export function humanChatLogs (accountId, lastMsgId, count) {
  return fetch({
    url: `/api/common/im-log/im/chat-log`,
    method: 'Get',
    params: {
      accountId,
      lastMsgId,
      count
    }
  })
}
